<div class="active-sessions-container">
  <div class="card">
    <div class="card-header">
      <h3>{{ 'users.activeSessions.title' | translate }}</h3>
      <p class="text-muted">
        {{ 'users.activeSessions.subtitle' | translate }}
      </p>
    </div>

    <div class="card-body">
      <!-- Loading state -->
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'users.activeSessions.loading' | translate }}</span>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="!loading && sessions.length === 0" class="empty-state text-center py-5">
        <i class="bi bi-shield-lock" style="font-size: 3rem; color: #6c757d;"></i>
        <p class="mt-3">{{ 'users.activeSessions.empty' | translate }}</p>
      </div>

      <!-- Sessions list -->
      <div *ngIf="!loading && sessions.length > 0" class="sessions-list">
        <div
          *ngFor="let session of sessions"
          class="session-item"
          [class.current-session]="session.isCurrent"
          [class.expiring-soon]="isExpiringSoon(session.expiresAt)"
        >
          <div class="session-icon">
            <i class="bi bi-device-{{ getDeviceIcon(session.deviceName) }}"></i>
          </div>

          <div class="session-info">
            <div class="session-device">
              <strong>{{ session.deviceName }}</strong>
              <span *ngIf="session.isCurrent" class="badge bg-success ms-2">
                {{ 'users.activeSessions.currentBadge' | translate }}
              </span>
              <span *ngIf="isExpiringSoon(session.expiresAt)" class="badge bg-warning ms-2">
                {{ 'users.activeSessions.expiringBadge' | translate }}
              </span>
            </div>

            <div class="session-details text-muted">
              <div class="detail-item">
                <i class="bi bi-geo-alt"></i>
                <span>{{ session.ipAddress }}</span>
                <span *ngIf="session.location"> - {{ session.location }}</span>
              </div>

              <div class="detail-item">
                <i class="bi bi-clock"></i>
                <span>{{ 'users.activeSessions.lastActive' | translate }}: {{ getRelativeTime(session.lastActivityAt) }}</span>
              </div>

              <div class="detail-item">
                <i class="bi bi-calendar"></i>
                <span>{{ 'users.activeSessions.created' | translate }}: {{ formatDate(session.createdAt) }}</span>
              </div>

              <div class="detail-item">
                <i class="bi bi-hourglass"></i>
                <span>{{ 'users.activeSessions.expires' | translate }}: {{ formatDate(session.expiresAt) }}</span>
              </div>
            </div>
          </div>

          <div class="session-actions">
            <button
              *ngIf="!session.isCurrent"
              class="btn btn-sm btn-outline-danger"
              (click)="revokeSession(session.id, session.deviceName)"
              [disabled]="revoking[session.id]"
            >
              <span *ngIf="!revoking[session.id]">
                <i class="bi bi-x-circle"></i>
                {{ 'users.activeSessions.revoke' | translate }}
              </span>
              <span *ngIf="revoking[session.id]">
                <span class="spinner-border spinner-border-sm" role="status"></span>
                {{ 'users.activeSessions.revoking' | translate }}
              </span>
            </button>

            <button
              *ngIf="session.isCurrent"
              class="btn btn-sm btn-secondary"
              disabled
            >
              <i class="bi bi-check-circle"></i>
              {{ 'users.activeSessions.thisDevice' | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Refresh button -->
      <div *ngIf="!loading && sessions.length > 0" class="mt-4 text-center">
        <button class="btn btn-outline-primary" (click)="loadActiveSessions()">
          <i class="bi bi-arrow-clockwise"></i>
          {{ 'users.activeSessions.refresh' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Info panel -->
  <div class="card mt-4">
    <div class="card-body">
      <h5 class="card-title">
        <i class="bi bi-info-circle text-info"></i>
        {{ 'users.activeSessions.aboutTitle' | translate }}
      </h5>
      <p class="card-text">
        {{ 'users.activeSessions.aboutText' | translate }}
      </p>
      <ul class="small text-muted">
        <li>{{ 'users.activeSessions.tip1' | translate }}</li>
        <li>{{ 'users.activeSessions.tip2' | translate }}</li>
        <li>{{ 'users.activeSessions.tip3' | translate }}</li>
      </ul>
    </div>
  </div>
</div>
